import axios from "axios";

export const fetchSpeedUnitTypes = async (enabledOnly) => {
    const response = await axios.get("api/speedUnitTypes/?enabledOnly=" + enabledOnly);
    const speedUnitTypes = response.data;
    return speedUnitTypes;
}